module.exports = __webpack_public_path__ + "static/media/03_sognolucido.4ada6e06.jpg";